module.exports = __webpack_public_path__ + "img/yxpt.a3370d5e.jpg";